module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ocx",
    staticStyle: {
      "width": "100%",
      "height": "97%",
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "90%",
      "height": "100%",
      "display": "inline-block"
    },
    attrs: {
      "id": "mainObject"
    }
  }, [_c('OBJECT', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "id": "control",
      "classid": "clsid:5CAC43BD-DE74-49F9-9FD6-DDA6B5A15A9C",
      "codebase": "KTSEDocAxEx.ocx"
    }
  }), _vm._v(" "), _c('OBJECT', {
    attrs: {
      "id": "FormPost",
      "classid": "clsid:019A29FA-4B5D-4FE8-82D4-51C554285457",
      "name": "FormPost"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "8%",
      "display": "inline-block",
      "vertical-align": "top"
    },
    attrs: {
      "id": "toolBar"
    }
  }, [(_vm.showDealStamp != false) ? _c('button', {
    staticClass: "ocxBtn btn btn-primary",
    attrs: {
      "disabled": _vm.loading,
      "type": "button"
    },
    on: {
      "click": _vm.DealStamp
    }
  }, [_vm._v("盖章")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "ocxBtn btn btn-primary",
    attrs: {
      "disabled": _vm.loading,
      "type": "button"
    },
    on: {
      "click": _vm.DealLotStamp
    }
  }, [_vm._v("批量盖章")]), _vm._v(" "), _c('button', {
    staticClass: "ocxBtn btn btn-primary",
    attrs: {
      "disabled": _vm.loading,
      "type": "button"
    },
    on: {
      "click": _vm.DealHandSign
    }
  }, [_vm._v("签批")]), _vm._v(" "), _c('button', {
    staticClass: "ocxBtn btn btn-primary",
    attrs: {
      "disabled": _vm.loading,
      "type": "button"
    },
    on: {
      "click": _vm.DealUnStamp
    }
  }, [_vm._v("撤销")]), _vm._v(" "), _c('button', {
    staticClass: "ocxBtn btn btn-primary",
    attrs: {
      "disabled": _vm.loading,
      "type": "button"
    },
    on: {
      "click": _vm.DealVerifyStamp
    }
  }, [_vm._v("验证")]), _vm._v(" "), _c('button', {
    staticClass: "ocxBtn btn btn-primary",
    attrs: {
      "disabled": _vm.loading,
      "type": "button"
    },
    on: {
      "click": _vm.saveAndUpload
    }
  }, [_vm._v("保存提交")]), _vm._v(" "), _c('button', {
    staticClass: "ocxBtn btn btn-primary",
    attrs: {
      "disabled": _vm.loading,
      "type": "button"
    },
    on: {
      "click": _vm.DealAdminStamp
    }
  }, [_vm._v("印章管理")]), _vm._v(" "), _c('button', {
    staticClass: "ocxBtn btn btn-primary",
    attrs: {
      "disabled": _vm.loading,
      "type": "button"
    },
    on: {
      "click": _vm.DealAdminOption
    }
  }, [_vm._v("系统设置")]), _vm._v(" "), _c('button', {
    staticClass: "ocxBtn btn btn-primary",
    attrs: {
      "disabled": _vm.loading,
      "type": "button"
    },
    on: {
      "click": _vm.CloseDocument
    }
  }, [_vm._v("退出")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48fbe5ae","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ocx.vue
// module id = 587
// module chunks = 143